module.exports = __webpack_public_path__ + "img/06-top-img@2x.3dffd45a.png";